export default {
  TEST_ONE: "testOne",
  TEST_TWO: "testTwo",
  HOS_DRIVERS: "hos-drivers",
  HOS_LOGS: "hos-logs",
  HOS_EVENTS: "hos-events",
  HOS_EVENTS_VIEW: "hos-events-view",
  HOS_EVENTS_MASTER: "hos-events-master",
  HOS_DRIVER_LOGS: "hos-driver-logs",
  HOS_DRIVER_LOG_VIEW: "hos-driver-log-view",
  HOS_EDIT_LOG_EVENT: "hos-edit-log-event",
  HOS_VIOLATIONS: "hos-violations",
  HOS_DRIVER_VIOLATIONS: "hos-driver-violations",
  HOS_RECENT_VIOLATIONS: "hos-recent-violations",
  HOS_DRIVER_VIOLATION_DOCUMENTS: "hos-driver-violation-documents",
  HOS_UNIDENTIFIED_DRIVING: "hos-unidentified-driving",
  HOS_ELD_DISCONNECTIONS: "hos-eld-disconnections",
  HOS_ELD_MALFUNCTIONS: "hos-eld-malfunctions",
  HOS_FMCSA_DATA_TRANSFER: "hos-fmcsa-data-transfer",
  ASSETS_VEHICLES: "assets-vehicles",
  ASSETS_TRAILERS: "assets-trailers",
  ASSETS_DVIR_HISTORY: "assets-dvir-history",
  ASSETS_DVIR_VEHICLE_HISTORY: "assets-dvir-vehicle-history",
  ASSETS_DVIR_VEHICLE_DEFECTS: "assets-dvir-vehicle-defects",
  ASSETS_MAINTENANCE_DASHBOARD: "assets-maintenance-dashboard",
  ASSETS_MAINTENANCE: "assets-maintenance",
  ASSETS_VEHICLE_MAINTENANCE: "assets-vehicle-maintenance",
  ASSETS_MALFUNCTIONS_DIAG: "assets-malfunctions-diag",
  ADMIN_COMPANIES: "admin-companies",
  ADMIN_FLEET_MANAGERS: "admin-fleet-managers",
  ADMIN_DRIVERS: "admin-drivers",
  ADMIN_DRIVERS_VIEW: "admin-drivers-view",
  ADMIN_VEHICLES: "admin-vehicles",
  ADMIN_VEHICLES_VIEW: "admin-vehicles-view",
  ADMIN_TRAILERS: "admin-trailers",
  ADMIN_TRAILER_GPS_PROVIDERS: "admin-trailer-gps-providers",
  ADMIN_FUEL_PROVIDERS: "admin-fuel-providers",
  ADMIN_GROUPS: "admin-groups",
  ADMIN_ROLES: "admin-roles",
  ADMIN_ELDS: "admin-elds",
  ADMIN_ELD_MESSAGES: "admin-eld-messages",
  ADMIN_NOTIFICATIONS: "admin-notifications",
  ADMIN_DVIR_FORMS: "admin-dvir-forms",
  ADMIN_API_CLIENTS: "admin-api-clients",
  ADMIN_GEOMETRIS_COMMANDS: "admin-geometris-commands",
  ADMIN_MOBILE_APP_VERSIONS: "admin-mobile-app-versions",
  MASTER_TENANTS: "master-tenants",
  MASTER_TENANTS_VIEW: "master-tenants-view",
  MASTER_TENANT_REGISTRATIONS: "master-tenant-registrations",
  MASTER_ELDS: "master-elds",
  MASTER_TENANT_ELDS: "master-tenant-elds",
  MASTER_TENANT_OWN_ELDS: "admin-tenant-own-elds",
  MASTER_TENANT_ELDS_USAGE: "master-tenant-elds-usage",
  MASTER_SUBSCRIPTIONS: "master-subscriptions",
  MASTER_FLEET_MANAGERS: "master-fleet-managers",
  MASTER_DEMO_ACCOUNTS: "admin-demo-accounts",
  MASTER_VIRTUAL_TENANTS: "admin-virtual-tenants",
  LOCATIONS_CURRENT: "locations-current",
  LOCATIONS_TRAILERS: "locations-trailers",
  LOCATIONS_LIVETRACK: "locations-livetrack",
  LOCATIONS_LIVETRACK_TOKENS: "locations-livetrack-tokens",
  LOCATIONS_HISTORY: "locations-history",
  LOCATIONS_HISTORY_VEHICLES: "locations-history-vehicles",
  LOCATIONS_STATE_TRIPS: "locations-state-trips",
  LOCATIONS_STATE_TRIPS_BY_STATE: "locations-state-trips-by-state",
  LOCATIONS_STATE_TRIPS_BY_VEHICLE: "locations-state-trips-by-vehicle",
  SAFETY_ALERTS: "safety-alerts",
  SAFETY_DASHBOARD: "safety-dashboard",
};
